import { apiSlice } from './apiSlice';

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Send OTP (registration mobile verification)
    sendOtp: builder.mutation<
      { message: string },
      { mobile: string; country?: string; type: 'register' }
    >({
      query: (body) => ({
        url: '/auth/send-code',
        method: 'POST',
        body,
        // Give up after 15s so the button comes back instead of waiting forever.
        timeout: 15_000,
      }),
    }),

    // Register
    register: builder.mutation<
      {
        accessToken: string;
        refreshToken?: string;
        type: string;
      },
      {
        firstname?: string;
        lastname?: string;
        username: string;
        email?: string;
        password: string;
        dialCode?: string;
        mobile?: string;
        country?: string;
        emailVerificationCode?: string;
        mobileVerificationCode?: string;
        referralCode?: string;
      }
    >({
      query: (body) => ({
        url: '/auth/register',
        method: 'POST',
        body,
        // Give up after 15s so the button comes back instead of waiting forever.
        timeout: 15_000,
      }),
    }),

    // Login
    login: builder.mutation<
      {
        success: boolean;
        accessToken?: string;
        type: string;
        role: { id: number; name: string };
        passwordChanged: boolean;
        mfaRequired?: boolean;
        isTelegramEnabled?: boolean;
      },
      {
        username: string;
        password: string;
        device: string;
        captchaId: string;
        captchaText: string;
      }
    >({
      query: (body) => ({
        url: '/auth/login',
        method: 'POST',
        body,
      }),
    }),

    //logout
    logout: builder.mutation<any, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
    }),

    // change password
    changePassword: builder.mutation({
      query: (body: { oldPassword: string; newPassword: string }) => ({
        url: '/users/me/change-password',
        method: 'POST',
        body,
        requiresAuth: true,
      }),
    }),

    // Captcha
    getCaptcha: builder.query<
      {
        enabled: boolean;
        captchaId: string;
        image: string;
      },
      void
    >({
      query: () => ({
        url: '/captcha',
        method: 'POST',
      }),
    }),

    //Demo Login
    demoLogin: builder.mutation<any, void>({
      query: () => ({
        url: '/auth/demo/login',
        method: 'POST',
      }),
    }),

    // Forgot password — sends a reset code to the mobile number
    forgotPassword: builder.mutation<
      { mobile?: { sentAt: string; timeout: number } },
      { mobile: string }
    >({
      query: (body) => ({
        url: '/auth/forgot-password',
        method: 'POST',
        body,
        // Give up after 15s so the button comes back instead of waiting forever.
        timeout: 15_000,
      }),
    }),

    // Reset password — verifies the code sent by forgotPassword and sets a new password
    resetPassword: builder.mutation<
      { status: string },
      { code: string; newPassword: string; mobile: string }
    >({
      query: (body) => ({
        url: '/auth/reset-password',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useSendOtpMutation,
  useRegisterMutation,
  useLoginMutation,
  useLogoutMutation,
  useChangePasswordMutation,
  useLazyGetCaptchaQuery,
  useDemoLoginMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
} = authApi;
